<template>
  <div class="page_content seltel_pg">

    <div class="seltel_carousel">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <h1>Gefeliciteerd!</h1>
            <h3>Bij Prepaid Surprise ben je altijd een winnaar!</h3>
            <h2>Kies je cadeau:</h2>
          </div>
        </div>
      </div>
      <div class="container telco_carousel_cont">
        <swiper class="swiper" :options="carouselOptions">
          <swiper-slide v-for="telco in getTelcoInfo" :key="telco.telcoName" class="swiper-slide d-flex flex-column">
            <div class="select_tlc_inside_slide" @click="selectTelcoPrize(telco.id)" :disabled="disabled">
              <img :src="telco.image" alt="">
              <p>
                {{ telco.name }}
              </p>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <div class="bot_text">
              Ik wil mijn Surprise prijs omruilen voor een extra draai aan het rad
            </div>
            <button type="button" @click="goToWheel" class="black_secondary_btn">Extra draai aan het rad
            </button>
            <div class="hashtag">#PrepaidSurprise</div>
          </div>
        </div>
      </div>
      <div class="banners_container">
        <a href="https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels" target="_blank">
          <img src="static/img/millen_images/banner_2_desktop.png" alt="Desktop Banner" class="banner_responsive_image banner_desktop_image">
          <img src="static/img/millen_images/banner_2_mobile.png" alt="Mobile Banner" class="banner_responsive_image banner_mobile_image">
        </a>
      </div>
    </div>
  </div>
</template>

<script>

  import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  import {mapActions, mapGetters, mapMutations} from 'vuex'
  import gameFlow from '../common/mixin/gameFlow'

  export default {
    name: 'TelcoPrize',
    components: {
      Swiper,
      SwiperSlide
    },
    mixins: [
      gameFlow
    ],
    data() {
      return {
        carouselOptions: {
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
              spaceBetween: 30,
            },
            320: {
              slidesPerView: 1.4,
              spaceBetween: 20,
              centeredSlides: true,
              initialSlide: 1
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }
        },
        selectedTelcoRewardId: 0,
        disabled: false,
        assignedSuccessfully: false
      }
    },
    computed: {
      ...mapGetters([
        'getGameResponse',
        'getTelcoInfo',
        'getTopUpValue',
        'getInGameFlow',
        'getSelectedCodeForRedemption'
      ])
    },
    mounted() {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.telcoNetworkInfo(this.getTelcoValidRewardIds)
      this.setInGameFlow("true", this.$route.path.substring(1))
    },
    methods: {
      ...mapMutations([
        'updateInGameFlow'
      ]),
      ...mapActions([
        'playGame'
      ]),
      findCorrectTelcoType(telcoId) {
        for (let telco of this.getTelcoInfo) {
          if (telcoId === telco.id) {
            this.selectedTelcoRewardId = telco.id
          }
        }
      },
      selectTelcoPrize(id) {
        this.findCorrectTelcoType(id)
        this.assignTelcoReward(false, this.selectedTelcoRewardId, false)
      },
      goToWheel() {
        this.assignTelcoReward(false, 0, true)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TelcoPrize.vue